// The picked inbounds and their typed amounts, as the fulfil forms keep them in form state.

// Each picked row keeps its typed values in form state under this prefix.
export const batchFieldPrefix = (rowId) => `batch_${rowId}_`;

// One picked row's typed value; used by the Allocate credit totals and the payload builder.
export const batchField = (values, rowId, key) =>
  values?.[`${batchFieldPrefix(rowId)}${key}`] ?? '';

/** The picked rows and what was typed against each → the fulfil payload's `batches`. */
export const buildBatchesFromValues = (values = {}) =>
  (values.selectedInbounds ?? []).map((rowId) => ({
    batchId: rowId,
    transactionId: batchField(values, rowId, 'idNumber'),
    certifiedQuantity: batchField(values, rowId, 'certifiedQuantity'),
  }));
